import { Injectable, signal } from '@angular/core';

export const AGENT_UI_PREFERENCE_KEY = 'TWINSIGHT_AGENT_UI_V1';
export const AGENT_MIN_WIDTH = 340;
export const AGENT_MAX_WIDTH = 740;

@Injectable({ providedIn: 'root' })
export class AgentUiStore {
  readonly open = signal(false);
  readonly width = signal(460);

  constructor() {
    try {
      const value: unknown = JSON.parse(localStorage.getItem(AGENT_UI_PREFERENCE_KEY) ?? 'null');
      if (typeof value !== 'object' || value === null) return;
      if ('open' in value && typeof value.open === 'boolean') this.open.set(value.open);
      if ('width' in value && typeof value.width === 'number' && Number.isFinite(value.width)) {
        this.resize(value.width);
      }
    } catch {
      // Storage can be unavailable; the dock still works in memory.
    }
  }

  toggle(): void {
    this.open.update(open => !open);
    this.save();
  }

  close(): void {
    this.open.set(false);
    this.save();
  }

  resize(width: number): void {
    if (Number.isFinite(width)) {
      this.width.set(Math.round(Math.min(AGENT_MAX_WIDTH, Math.max(AGENT_MIN_WIDTH, width))));
    }
  }

  save(): void {
    try {
      localStorage.setItem(AGENT_UI_PREFERENCE_KEY, JSON.stringify({ open: this.open(), width: this.width() }));
    } catch {
      // Preferences are optional and never contain conversation or workspace data.
    }
  }
}
